import { createLogger as createLoggerInternal, Plugin } from 'vuex';

import { ENV } from '@/utils/env';

export function createLogger(): Plugin<unknown> | null {
    return ['production', 'test'].includes(ENV.NODE_ENV) || !ENV.VUE_APP_VUEX_LOGGER
        ? null
        : createLoggerInternal();
}
